import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "../../lib/api";

const FIELDS = [
  ["TOKEN SAFETY GATE", [
    ["min_liquidity_usd", "Min liquidity ($)", 1000], ["max_top_holders_pct", "Max top-holders (%)", 1], ["min_holders", "Min holders", 10],
    ["min_age_min", "Min age (min)", 1], ["max_age_hours", "Max age (h)", 1], ["max_price_impact_pct", "Max price impact (%)", 0.1],
    ["max_sell_buy_ratio_5m", "Max 5m sell/buy ratio", 0.1], ["max_liquidity_drop_1h_pct", "Max 1h liq drop (%)", 1], ["max_rugcheck_score", "Max RugCheck score", 1],
  ]],
  ["CONSENSUS", [["entry_score", "Entry score (−1…1)", 0.01], ["agent_cooldown_min", "Agent cooldown (min)", 1], ["max_agent_evals_per_scan", "Agent evals / scan", 1]]],
  ["RISK SUPERVISOR · SHADOW BOOK", [
    ["shadow_capital_usd", "Shadow capital ($)", 10], ["position_usd", "Position size ($)", 1], ["max_open_positions", "Max open positions", 1],
    ["max_exposure_usd", "Max exposure ($)", 5], ["daily_loss_limit_usd", "Daily loss limit ($)", 1], ["reentry_cooldown_min", "Re-entry cooldown (min)", 1],
  ]],
  ["MICRO LIVE · HARD CAPS (SOL)", [
    ["live_sol_per_trade", "Buy size (SOL)", 0.005], ["live_max_sol_per_trade", "Per-trade cap (SOL, max 0.05)", 0.005], ["live_daily_sol_cap", "Daily spend cap (SOL)", 0.01],
    ["live_max_open", "Max live positions", 1], ["live_reserve_sol", "Wallet reserve (SOL)", 0.005],
  ]],
  ["POSITION MANAGEMENT", [
    ["stop_pct", "Stop (%)", 1], ["tp1_pct", "TP1 (%)", 1], ["tp1_take_frac", "TP1 take fraction", 0.05], ["tp2_pct", "TP2 (%)", 5],
    ["trail_pct", "Trail from high (%)", 1], ["time_stop_hours", "Time stop (h)", 0.5], ["slippage_bps", "Modelled slippage (bps)", 5],
  ]],
];

export const MemeSettings = ({ cfg, onSaved, onClose }) => {
  const [form, setForm] = useState({});
  useEffect(() => { if (cfg) setForm(Object.fromEntries(FIELDS.flatMap(([, fs]) => fs.map(([k]) => [k, cfg[k]])))); }, [cfg]);
  const save = async () => {
    try { await api.meme.config(form); toast.success("Meme limits saved"); onSaved?.(); onClose?.(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Save failed"); }
  };
  return (
    <aside className="fixed right-0 top-11 bottom-0 w-[360px] z-40 r2-glass border-l border-[var(--r2-border)] overflow-auto p-4 space-y-4" data-testid="meme-settings">
      <div className="flex items-center justify-between"><span className="text-[10px] font-mono tracking-[0.22em] text-[var(--meme)]">MEME LIMITS</span><button onClick={onClose} data-testid="meme-settings-close" className="text-[var(--r2-text2)] hover:text-white text-[10px] font-mono">CLOSE ✕</button></div>
      <div className="text-[8.5px] font-mono text-[var(--r2-text2)] leading-relaxed">Execution mode is switched from the header (ARM MICRO LIVE). The SOL caps below are enforced by the executor on every real buy — agents cannot override them; the per-trade cap is hard-limited to 0.05 SOL.</div>
      {FIELDS.map(([title, fs]) => (
        <section key={title}>
          <div className="text-[8px] font-mono tracking-[0.2em] text-[var(--r2-text2)] mb-1.5">{title}</div>
          <div className="grid grid-cols-2 gap-2">
            {fs.map(([k, label, step]) => (
              <label key={k} className="block"><span className="block text-[7.5px] font-mono tracking-[0.12em] text-[var(--r2-text2)]">{label}</span>
                <input type="number" step={step} value={form[k] ?? ""} onChange={(e) => setForm((f) => ({ ...f, [k]: Number(e.target.value) }))} data-testid={`meme-cfg-${k}`}
                  className="w-full bg-black/30 border border-[var(--r2-border)] rounded px-1.5 py-1 text-[10px] font-mono text-[var(--r2-text1)] focus:border-[var(--meme)] outline-none" /></label>
            ))}
          </div>
        </section>
      ))}
      <button onClick={save} data-testid="meme-settings-save" className="w-full rounded-md py-2 text-[10px] font-mono tracking-[0.22em] font-bold text-black bg-[var(--meme)] hover:brightness-110 transition-[filter]">SAVE LIMITS</button>
    </aside>
  );
};
